export const contact_us = {
  email: "microsoftclub@daiict.ac.in",
  address: "DAIICT-campus, near Reliance Cross Rd, Gandhinagar, Gujarat 382007",
  github: "https://github.com/MSTC-DA-IICT",
  linkedin:
    "https://www.linkedin.com/company/microsoft-student-technical-club-da-iict/",
  youtube: "https://www.youtube.com/@mstcda-iict9181",
  instagram: "https://www.instagram.com/mstc_daiict/",
};
